import chakraTokenToVar from '@/utils/chakraTokenToVar'
import { FONT_FAMILY, LINE_HEIGHTS } from '@/constants/constants'

export default {
  global: {
    '*': { boxSizing: 'border-box' },
    html: { fontSize: '100%' },
    body: {
      margin: 0,
      padding: 0,
      fontFamily: FONT_FAMILY.default,
      lineHeight: LINE_HEIGHTS.default,
      overflowWrap: 'break-word',
      wordWrap: 'break-word',
      color: 'fg',
    },
    '#nprogress .bar': { background: 'primary.solid' },
    '#nprogress .peg': {
      boxShadow: `0 0 10px ${chakraTokenToVar('primary.solid')}, 0 0 5px ${chakraTokenToVar('primary.solid')}`,
    },
    '#nprogress .spinner-icon': { display: 'none' },
    ul: { margin: 0 },
  },
}
